// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__36n00","text":"SelectPayment_text__uFLcc","title":"SelectPayment_title__KrLfB","btn":"SelectPayment_btn__A6R77"};